import { render, staticRenderFns } from "./WebchatInstallation.vue?vue&type=template&id=f0d819d0&scoped=true&"
import script from "./WebchatInstallation.vue?vue&type=script&lang=js&"
export * from "./WebchatInstallation.vue?vue&type=script&lang=js&"
import style0 from "./WebchatInstallation.vue?vue&type=style&index=0&id=f0d819d0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d819d0",
  null
  
)

export default component.exports